import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import SingleSourceComponent from './SingleSource/SingleSource';
import GeneralFiltersComponent from './generalFilters/generalFilters';
import SalesMeetingFormSimpleComponent from '../createMeeting/SalesMeetingFormSimple';
import { Document, Page, Text, View, StyleSheet, ReactPDF, PDFDownloadLink } from '@react-pdf/renderer';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import FeedbackFormComponent from './feedbackForm/FeedbackFormComponent';
import * as GeneralDataPdfUtils from './generalData/generalDataPdf';
import * as AnalyticsUtils from "../../../common/AnalyticsSvc";
import * as Utils from '../../../common/utilSvc';
import * as DbUtils from '../../../common/DbSvc';
import * as Const from '../../../common/const';
import * as CoreHelper from '../../../common/coreHelper';
import './Meeting.css';
import firebase from "firebase/app";
import "firebase/analytics";
import 'firebase/firestore';
import 'firebase/functions';
import { isNullOrUndefined } from "util";
import CreateSourceComponent from './createSource/createSource';
import GeneralDataComponent from './generalData/generalData';


class MeetingV1Component extends React.Component {
    
    constructor(props){

        //Props include meeting, userId
        super(props);

        this.state = {
            isCopied: false,
            createSource: false,
            sources: [],
            originalSources: [],
            saveStatus: {},
            isCollapsed: {},
            meetingActivity: {},
            isLoading: {},
            generalData: {},
            generalFilters: {
                'Summary': true,
                'Key Facts': true,
                'News': true,
                'Financial Details': true
            },
            meeting: {
                'company': JSON.parse(JSON.stringify(this.props.company))
            },
            amCharts: {},
            flags: {
                showGeneralFilters: false
            },
            showFeedback: false,
            keywordFilterCategories: [],
            newsSummaries: {}
        }

        this.clickOnKeyWordFilter = this.clickOnKeyWordFilter.bind(this);
        this.filterGoogleNewsResults = this.filterGoogleNewsResults.bind(this);
        this.getAllData = this.getAllData.bind(this);
        this.createTempMeeting = this.createTempMeeting.bind(this);
        this.getCompanyCompetitors = this.getCompanyCompetitors.bind(this);
        this.getCompanyMission = this.getCompanyMission.bind(this);
        this.getCompanyWikiData = this.getCompanyWikiData.bind(this);
        this.postWikiFunction = this.postWikiFunction.bind(this);
        this.getCompanyGoogleSearchData = this.getCompanyGoogleSearchData.bind(this);
        this.getCompanyGoogleNewsData = this.getCompanyGoogleNewsData.bind(this);
        this.getCyberGoogleNewsData = this.getCyberGoogleNewsData.bind(this);
        this.getCyberIndustryNewsData = this.getCyberIndustryNewsData.bind(this);
        this.getCyberIndustryNewsDataV2 = this.getCyberIndustryNewsDataV2.bind(this);
        this.getFundingData = this.getFundingData.bind(this);
        this.getGeneralDataFromDb = this.getGeneralDataFromDb.bind(this);
        this.getMissingWikiKeys = this.getMissingWikiKeys.bind(this);
        this.getPublicStockRelatedData = this.getPublicStockRelatedData.bind(this);
        this.getOpenAISummary = this.getOpenAISummary.bind(this);
        this.googleApiCall = this.googleApiCall.bind(this);
        this.googleApiCallListResults = this.googleApiCallListResults.bind(this);
        this.getSingleSourceOpenAISummary = this.getSingleSourceOpenAISummary.bind(this);
        this.getTenK_cyberData = this.getTenK_cyberData.bind(this);
        this.googleNewsApiCall = this.googleNewsApiCall.bind(this);
        this.googleNlpEntityExtraction = this.googleNlpEntityExtraction.bind(this);
        this.scrapeSingleWikiLink = this.scrapeSingleWikiLink.bind(this);
        this.scrapeSingleUrl = this.scrapeSingleUrl.bind(this);
        this.stockTickerFromWikiApiCall = this.stockTickerFromWikiApiCall.bind(this);
        this.setAmChart = this.setAmChart.bind(this);
        this.toggleGeneralFilter = this.toggleGeneralFilter.bind(this);
        this.yahooIncomeStatementApiCall = this.yahooIncomeStatementApiCall.bind(this); 
        this.getNewsSummaries = this.getNewsSummaries.bind(this);
        this.setLoadingState = this.setLoadingState.bind(this);
        this.getWebsiteTechStack = this.getWebsiteTechStack.bind(this);
        this.getSingleNewsArticleSummary = this.getSingleNewsArticleSummary.bind(this);

        this.scrapeCyberNewsArticleSummary = this.scrapeCyberNewsArticleSummary.bind(this);

        this.handleFilterKeywordChange = this.handleFilterKeywordChange.bind(this);
        this.renderKeywordsFilter = this.renderKeywordsFilter.bind(this);

        this.getDocument = this.getDocument.bind(this);


        this.meetingSourcesListener = null;
        this.meetingRealtimeActivityListener = null;
    }

    setLoadingState(type, val){
        if(!isNullOrUndefined(type)){
            let isLoading = this.state.isLoading;
            isLoading[type] = val;
            this.setState({
                isLoading: isLoading
            });
        }
    }

    async getAllData(company){
        // console.log(company);
        this.setState({
            generalData: {}
        })
        this.getCompanyMission(company);
        this.getCompanyGoogleSearchData(company);
        this.getCompanyGoogleNewsData(company);
        this.getCyberGoogleNewsData(company);
    }

    async getTenK_cyberData(ticker){

        this.setLoadingState('tenK_cyber',true);

        let filters = [];
        for(let i=0; i<Const.cyberSECFields.length; i++){
            filters.push({
                text: Const.cyberSECFields[i],
                score: 1
            })
        }
        let tenK_data = await CoreHelper.secDbApiCall(ticker, '10-K','risk factors',filters);
        // console.log(tenK_data);
        if(isNullOrUndefined(tenK_data) || tenK_data.length==0){
            await CoreHelper.saveSecInDbApiCall(ticker,"10-K");
            tenK_data = await CoreHelper.secDbApiCall(ticker, '10-K','risk factors',filters);
        }

        if(tenK_data.length > 0){
            let textArrSummaryPromise = [];
            for(let i=0; i<tenK_data.length; i++){
                let textArr = tenK_data[i].data;
                if(isNullOrUndefined(textArr))
                    textArr=[];
                let textArrSummary = CoreHelper.getSecArraySummary(textArr, filters);
                textArrSummaryPromise.push(textArrSummary);
            }

            let textArrSummaries = await Promise.all(textArrSummaryPromise);
            // console.log(textArrSummaries);
            // console.log(tenK_data);
            
            for(let i=0; i<textArrSummaries.length; i++){
                if(textArrSummaries[i].length>0){
                    let summData = [];
                    for(let j=0; j<textArrSummaries[i].length;j++){
                        summData.push({
                            'text': textArrSummaries[i][j]
                        });
                    }
                    tenK_data[i]['data'] = summData;
                }
            }
            // console.log(tenK_data);
            if('data' in tenK_data[0] && tenK_data[0]['data'].length>0){
                let generalData = this.state.generalData;
                generalData['tenK_cyber'] = tenK_data;
                this.setState({ generalData: generalData}); 
            }
        }

        this.setLoadingState('tenK_cyber',false);
    }

    async getCompanyMission(company){
        this.setLoadingState('companyMission',true);

        // console.log(company);
        if(!isNullOrUndefined(company) && company.trim().length>0){
            //TODO Check if link is valid here
        
            const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleSearchPull';
            // console.log(endpoint);
            let searchQuery = "what is " + company +" mission?";
            if(CoreHelper.getCompanyWords(company).length>2){
                searchQuery = "what is " + company +" company mission?";
            }
            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'query': searchQuery}),
                    headers: new Headers({'content-type': 'application/json'})
                }
                )
            .catch((err)=>{console.log(err)});  
            if(!isNullOrUndefined(res)){
                let resJson = await res.json();

                if('answer_box' in resJson){
                    let companyMission = {};
                    let answer = resJson['answer_box'];
                    // console.log(answer);

                    if('title' in answer){
                        companyMission['title'] = answer['title'];
                    }
                    if('snippet' in answer){
                        companyMission['snippet'] = answer['snippet'];
                    }
                    if('link' in answer){
                        companyMission['link'] = answer['link'];
                    }

                    let generalData = this.state.generalData;
                    generalData['companyMission'] = companyMission;
                    this.setState({
                        generalData: generalData
                    });
                }                         
            }  
            
        }

        this.setLoadingState('companyMission', false);
    }

    async filterGoogleNewsResults(results, company){
        // console.log(results);
        if(isNullOrUndefined(results) || isNullOrUndefined(company))    
            return [];

        /* 
        NLP research
        // Get Google NLP answer here
        let str = company + " is a company. ";
        for(let i=0; i<results.length; i++){
            if('title' in results[i]){
                results[i]['startOffset'] = str.length;
                str += results[i].title +'\n';
                results[i]['endOffset'] = str.length - 1;
            }
        }

        
        //cMap gets those locations where substring is present in string
        let cMap = CoreHelper.getIndicesOfCompanyNamesInString(str, company);
        let smallStr = str.toLowerCase();
        let newStr = "";
        for(let i=0; i<str.length; i++){
            if(i in cMap){
                for(let j=i; j<=cMap[i] && j<str.length; j++)
                    newStr += str[j];
                i = cMap[i];                
            }
            else{
                newStr += smallStr[i];
            }
        }
        str = newStr;

       let nlpResults = await this.googleNlpEntityExtraction(str);
       console.log(str);
       console.log(nlpResults);
       let relevantNlpResultMentions = [];
       for(let i=0; i<nlpResults.length; i++){
           let nlpResult = nlpResults[i];

           if('name' in nlpResult && nlpResult.name.toLowerCase().includes(company.toLowerCase())){
               if('mentions' in nlpResult){
                for(let j=0; j<nlpResult.mentions.length; j++){
                    if('beginOffset' in nlpResult.mentions[j] && nlpResult.mentions[j].type=="PROPER")
                        relevantNlpResultMentions.push(nlpResult.mentions[j].beginOffset);
                }
               }
           }
       }
       relevantNlpResultMentions.sort((a,b) => {return a-b});
       console.log(results, relevantNlpResultMentions);
        */
       
        let companyWords = CoreHelper.getCompanyWords(company); 
        let companySubstrings = CoreHelper.createLinearSubstringsForCompany(companyWords);
        // console.log(companyWords, companySubstrings)
        let finalAns = [];
        for(let i=0; i<results.length; i++){
            // console.log(results[i].title.toLowerCase(), company.toLowerCase());
            // Old way
            for(let j=0; j<companySubstrings.length; j++){
                let currCompanyStr = companySubstrings[j];
                if('title' in results[i] && j>= companySubstrings.length-2 &&
                results[i].title.toLowerCase().includes(currCompanyStr.toLowerCase())){                
                    finalAns.push(results[i]);
                }
            }            

            /* 
            // NLP Research
            for(let j=0; j<relevantNlpResultMentions.length; j++){
                if(relevantNlpResultMentions[j]>=results[i].startOffset
                    && relevantNlpResultMentions[j]<=results[i].endOffset){
                        finalAns.push(results[i]);
                    }
            }
            */
        }

        //Bucketing
        let buckets = {
            'other':[], 'revenue':[], 'growth':[], 'market':[], 'funding': []
        }
        for(let i=0; i<finalAns.length; i++){
            let othersFlag = true;
            if(finalAns[i].title.toLowerCase().includes('revenue') || finalAns[i].title.toLowerCase().includes('sales')
            || finalAns[i].title.toLowerCase().includes('earning')){
                buckets['revenue'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('growth')){
                buckets['growth'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('fund') || finalAns[i].title.toLowerCase().includes('raise')){
                buckets['funding'].push(finalAns[i]);
                othersFlag = false;
            }
            if(finalAns[i].title.toLowerCase().includes('product') || finalAns[i].title.toLowerCase().includes('expan') || 
            finalAns[i].title.toLowerCase().includes('market') ){
                buckets['market'].push(finalAns[i]);
                othersFlag = false;
            }
            if(othersFlag){
                buckets.other.push(finalAns[i]);
            }
        }
        // console.log(buckets);

        //Retrieve top news based on buckets
        let keys = ['growth', 'funding', 'market', 'revenue', 'other'];
        let added = {};
        let topNewsOutput = [];
        let maxLimit = Const.maxNewsArticles;
        for(let i=0; i<keys.length; i++){
            let bucketKeyArr = buckets[keys[i]];
            let cnt = 0, limit = 1;
            if(i==keys.length-1){
                limit = maxLimit - topNewsOutput.length;
            }
            for(let j=0;j<bucketKeyArr.length && cnt<limit; j++){
                let newsItem = bucketKeyArr[j];
                if(!(newsItem.link in added)){
                    added[newsItem.link] = '';
                    cnt++;
                    topNewsOutput.push(newsItem);        
                }
            }
        }
        // console.log(topNewsOutput);
        
        return topNewsOutput;
    }

    async getCyberIndustryNewsDataV2(industryArr){

        // console.log(industryArr);

        //get news from industry name like "Manufacturing, additive, etc."

        this.setLoadingState('cyberIndustryNewsV2',true);

        let cyberIndustryNewsQuery = Const.cyberIndustryNewsQuery;

        if(!isNullOrUndefined(industryArr) && industryArr.length>0)
        {
            let output = [], industryIndex = {};
            for(let k=0; k<industryArr.length; k++){
                let industry = industryArr[k].trim();
                
                // console.log(industry);

                industryIndex[industry] = {'start':output.length}
            
                for(let i=0; i<cyberIndustryNewsQuery.length; i++){       
                    let query = "";         
                    let currNewsQuery = cyberIndustryNewsQuery[i].data;
                    for(let j=0; j<currNewsQuery.length; j++){
                        if(currNewsQuery[j] == "#")
                            query += industry;
                        else 
                            query += currNewsQuery[j];
                    }
                    // console.log(query);

                    if(cyberIndustryNewsQuery[i].type == "news"){
                        let result = this.googleNewsApiCall(query);
                        output.push(result);
                    }
                    else if(cyberIndustryNewsQuery[i].type == "search"){
                        let result = this.googleApiCallListResults(query, 0, {'industry':industry, 'category':'cybernews'});
                        output.push(result);
                    }
                }
                industryIndex[industry]['end'] = output.length; 
            }

            let finalOutput = await Promise.all(output);
            // console.log(finalOutput);

            let commonOutput = [];
            let existingLinks = {};
            for(let i=0; i<finalOutput.length; i++){
                for(let j=0; !isNullOrUndefined(finalOutput[i]) &&
                 j<finalOutput[i].length; j++){
                     let link = finalOutput[i][j].link;
                     if(!(link in existingLinks) && 'date' in finalOutput[i][j]){
                        let parsedDate = Date.parse(finalOutput[i][j].date);
                        let isSearchResult = false;
                        if(cyberIndustryNewsQuery[i%(cyberIndustryNewsQuery.length)].type == 'search')
                            isSearchResult = true;

                        //If date is valid for search Result OR if it is news result
                        if(!isSearchResult || (!isNaN(parsedDate))){
                            commonOutput.push(finalOutput[i][j]);
                            existingLinks[link] = '';                                
                        }
                     }
                 }
            }
            // console.log(commonOutput);

            let bucketOutputPromises = [];
            for(let k=0; k<industryArr.length; k++){
                let industry = industryArr[k];
                let cyberNewsBuckets =  CoreHelper.filterCyberNewsResultsForIndustry(commonOutput, industry);
                //Industry cannot be matched perfectly here
                bucketOutputPromises.push(cyberNewsBuckets);
            }
            let cyberIndustryBuckets = await Promise.all(bucketOutputPromises);
            // console.log(cyberIndustryBuckets);
            let cyberIndustryNews = CoreHelper.getIndustryCyberNewsArrFromBuckets(cyberIndustryBuckets);
            // console.log(cyberIndustryNews);

            if(cyberIndustryNews.length>0){
                let generalData = this.state.generalData;
                generalData['cyberIndustryNewsV2'] = cyberIndustryNews;
                this.setState({generalData: generalData});

                this.scrapeCyberNewsArticleSummary(cyberIndustryNews, 'cyberIndustryNewsV2');
            }
            
        }
        this.setLoadingState('cyberIndustryNewsV2',false);

    }

    async scrapeCyberNewsArticleSummary(newsArr, type){
        // console.log(newsArr);

        let summaryPromises = [];
        let links = []
        let keywords = [];
        for(let i=0; i<Const.cyberNewsKeywordsForUI['all'].length; i++){
            keywords.push({
                'text': Const.cyberNewsKeywordsForUI['all'][i],
                'score': 1
            })
        }
        for(let i=0; i<newsArr.length; i++){
            if(newsArr[i].link){
                links.push(newsArr[i].link)
                this.getSingleNewsArticleSummary(newsArr[i].link, keywords)
                // summaryPromises.push(CoreHelper.getNewsArticleSummary(newsArr[i].link, keywords))
            } 
        }
/*        let summaries = await Promise.all(summaryPromises);
        // console.log(summaries);

        let linkMap = this.state.newsSummaries;
        for(let i=0; i<links.length; i++){
            if(!isNullOrUndefined(summaries[i]) && summaries[i].length>0)
                linkMap[links[i]] = summaries[i];
        }

        this.setState({newsSummaries: linkMap});
        */
    }

    async getSingleNewsArticleSummary(link, keywords){
        let summary = await CoreHelper.getNewsArticleSummary(link, keywords);

        if(!isNullOrUndefined(summary) && summary.length>0){
            let linkMap = this.state.newsSummaries;
            linkMap[link] = summary;
            this.setState({newsSummaries: linkMap});
        }
    }

    async getCyberIndustryNewsData(companyArr){
        
        //get news from similar companies

        this.setLoadingState('cyberIndustryNews',true);

        let cyberCompanyNewsQuery = Const.cyberIndustryCompanyNewsQuery;

        if(!isNullOrUndefined(companyArr) && companyArr.length>0)
        {
            let output = [], companyIndex = {};
            for(let k=0; k<companyArr.length; k++){
                let company = companyArr[k].trim();
                let companyWords = CoreHelper.getCompanyWords(company);
                if(companyWords.length>2){
                    company = companyWords[0]+" "+companyWords[1];
                }
                // console.log(company);

                companyIndex[company] = {'start':output.length}
            
                for(let i=0; i<cyberCompanyNewsQuery.length; i++){       
                    let query = "";         
                    let currNewsQuery = cyberCompanyNewsQuery[i].data;
                    for(let j=0; j<currNewsQuery.length; j++){
                        if(currNewsQuery[j] == "#")
                            query += company;
                        else 
                            query += currNewsQuery[j];
                    }
                    // console.log(query);

                    if(cyberCompanyNewsQuery[i].type == "news"){
                        let result = this.googleNewsApiCall(query);
                        output.push(result);
                    }
                    else if(cyberCompanyNewsQuery[i].type == "search"){
                        let result = this.googleApiCallListResults(query, 0, {'company':company, 'category':'cybernews'});
                        output.push(result);
                    }
                }
                companyIndex[company]['end'] = output.length; 
            }

            let finalOutput = await Promise.all(output);
            // console.log(finalOutput);

            let commonOutput = [];
            let existingLinks = {};
            for(let i=0; i<finalOutput.length; i++){
                for(let j=0; !isNullOrUndefined(finalOutput[i]) &&
                 j<finalOutput[i].length; j++){
                     let link = finalOutput[i][j].link;
                     if(!(link in existingLinks) && 'date' in finalOutput[i][j]){
                        let parsedDate = Date.parse(finalOutput[i][j].date);
                        let isSearchResult = false;
                        if(cyberCompanyNewsQuery[i%(cyberCompanyNewsQuery.length)].type == 'search')
                            isSearchResult = true;

                        //If date is valid for search Result OR if it is news result
                        if(!isSearchResult || (!isNaN(parsedDate))){
                            commonOutput.push(finalOutput[i][j]);
                            existingLinks[link] = '';                                
                        }
                     }
                 }
            }
            // console.log(commonOutput);

            let bucketOutputPromises = [];
            for(let k=0; k<companyArr.length; k++){
                let company = companyArr[k];
                let cyberNewsBuckets =  CoreHelper.filterCyberNewsResults(commonOutput, company);
                bucketOutputPromises.push(cyberNewsBuckets);
            }
            let cyberIndustryBuckets = await Promise.all(bucketOutputPromises);
            // console.log(cyberIndustryBuckets);
            let cyberIndustryNews = CoreHelper.getIndustryCyberNewsArrFromBuckets(cyberIndustryBuckets);
            // console.log(cyberIndustryNews);

            if(cyberIndustryNews.length>0){
                let generalData = this.state.generalData;
                generalData['cyberIndustryNews'] = cyberIndustryNews;
                this.setState({generalData: generalData});

                this.scrapeCyberNewsArticleSummary(cyberIndustryNews, 'cyberIndustryNews');
            }
            
        }
        this.setLoadingState('cyberIndustryNews',false);

    }

    async getCyberGoogleNewsData(company){
        this.setLoadingState('cyberNews',true);

        let cyberCompanyNewsQuery = Const.cyberCompanyNewsQuery;

        if(!isNullOrUndefined(company) && company.trim().length>0){
            
            company = company.trim();
            let output = [];
            
            for(let i=0; i<cyberCompanyNewsQuery.length; i++){       
                let query = "";         
                let currNewsQuery = cyberCompanyNewsQuery[i].data;
                for(let j=0; j<currNewsQuery.length; j++){
                    if(currNewsQuery[j] == "#")
                        query += company;
                    else 
                        query += currNewsQuery[j];
                }
                // console.log(query);

                if(cyberCompanyNewsQuery[i].type == "news"){
                    let result = this.googleNewsApiCall(query);
                    output.push(result);
                }
                else if(cyberCompanyNewsQuery[i].type == "search"){
                    let result = this.googleApiCallListResults(query, 0, {'company':company.toLowerCase(), 'category':'cybernews'});
                    output.push(result);
                }
            }     
            let finalOutput = await Promise.all(output);
            // console.log(finalOutput);

            let commonOutput = [];
            let existingLinks = {};
            for(let i=0; i<finalOutput.length; i++){
                for(let j=0; !isNullOrUndefined(finalOutput[i]) &&
                 j<finalOutput[i].length; j++){
                     let link = finalOutput[i][j].link;
                     if(!(link in existingLinks) && 'date' in finalOutput[i][j]){
                        let parsedDate = Date.parse(finalOutput[i][j].date);
                        let isSearchResult = false;
                        if(cyberCompanyNewsQuery[i].type == 'search')
                            isSearchResult = true;

                        //If date is valid for search Result OR if it is news result
                        if(!isSearchResult || (!isNaN(parsedDate))){
                            commonOutput.push(finalOutput[i][j]);
                            existingLinks[link] = '';                                
                        }
                     }
                 }
            }
            // console.log(commonOutput);

            let cyberNewsBuckets = await CoreHelper.filterCyberNewsResults(commonOutput, company);
            //console.log(cyberNewsBuckets);
            let generalData = this.state.generalData;
            generalData['cyberNews'] = cyberNewsBuckets;
            this.setState({generalData: generalData});

            if(!isNullOrUndefined(cyberNewsBuckets) && 'cyberIncidents' in cyberNewsBuckets){
                let cyberIncidents = cyberNewsBuckets['cyberIncidents'];
                if(!isNullOrUndefined(cyberIncidents) && cyberIncidents.length){
                    this.scrapeCyberNewsArticleSummary(cyberIncidents, 'cyberIncidents');
                }
            }
            
            /*
            let finalArr = await this.filterGoogleNewsResults(commonOutput, company);
            // console.log(finalArr);

            let generalData = this.state.generalData;
            generalData['cyberNews'] = finalArr;
            this.setState({generalData: generalData});
            // this.getNewsSummaries(finalArr, company);
            */
        }

        this.setLoadingState('cyberNews',false);
    }

    async getCompanyGoogleNewsData(company){

        this.setLoadingState('company_google_news',true);

        let generalCompanyNewsQuery = Const.generalCompanyNewsQuery;

        if(!isNullOrUndefined(company) && company.trim().length>0){
            
            company = company.trim();
            let output = [];
            
            for(let i=0; i<generalCompanyNewsQuery.length; i++){       
                let query = "";         
                let currNewsQuery = generalCompanyNewsQuery[i].data;
                for(let j=0; j<currNewsQuery.length; j++){
                    if(currNewsQuery[j] == "#")
                        query += company;
                    else 
                        query += currNewsQuery[j];
                }
                // console.log(query);

                if(generalCompanyNewsQuery[i].type == "news"){
                    let result = this.googleNewsApiCall(query);
                    output.push(result);
                }
                else if(generalCompanyNewsQuery[i].type == "search"){
                    let result = this.googleApiCallListResults(query, 0, {'company':company.toLowerCase(), 'category':'general-news'});
                    output.push(result);
                }
            }     
            let finalOutput = await Promise.all(output);
            // console.log(finalOutput);

            let commonOutput = [];
            let existingLinks = {};
            for(let i=0; i<finalOutput.length; i++){
                for(let j=0; !isNullOrUndefined(finalOutput[i]) &&
                 j<finalOutput[i].length; j++){
                     let link = finalOutput[i][j].link;
                     if(!(link in existingLinks) && 'date' in finalOutput[i][j]){
                        let parsedDate = Date.parse(finalOutput[i][j].date);
                        let isSearchResult = false;
                        if(generalCompanyNewsQuery[i].type == 'search')
                            isSearchResult = true;

                        //If date is valid for search Result OR if it is news result
                        if(!isSearchResult || (!isNaN(parsedDate))){
                            commonOutput.push(finalOutput[i][j]);
                            existingLinks[link] = '';                                
                        }
                     }
                 }
            }
            // console.log(commonOutput);

            let finalArr = await this.filterGoogleNewsResults(commonOutput, company);
            // console.log(finalArr);

            let generalData = this.state.generalData;
            generalData['companyNews'] = finalArr;
            this.setState({generalData: generalData});
            this.setLoadingState('company_google_news',false);

            this.getNewsSummaries(finalArr, company);
        }
    }

    async getNewsSummaries(newsArr, company){

        if(isNullOrUndefined(newsArr) || isNullOrUndefined(company)){
            return []
        }

        let keyWords = [];
        let companyArr = CoreHelper.getCompanyWords(company);
        let otherWords = ["revenue","growth","earnings","product","expansion","partner","expand"];
        for(let i=0; i<companyArr.length; i++){
            keyWords.push({
                text: companyArr[i],
                score: 2
            });
        }
        for(let i=0; i<otherWords.length; i++){
            keyWords.push({
                text: otherWords[i],
                score: 1
            });
        }

        let scrapeOutputPromise = [];
        for(let i=0; i<newsArr.length; i++){
            let scrapeArr = this.scrapeSingleUrl(newsArr[i].link, keyWords);
            scrapeOutputPromise.push(scrapeArr);
        }

        let scrapeOutput = await Promise.all(scrapeOutputPromise);
        let scrapeTextOutput = [];
        for(let i=0; i<scrapeOutput.length; i++){
            scrapeOutput[i] = CoreHelper.sortParasScores(scrapeOutput[i], Const.maxParasForNewsSummary);
            scrapeTextOutput.push(CoreHelper.getAggregatedParaText(scrapeOutput[i], 2))
        }
        // console.log(scrapeOutput);
        // console.log(scrapeTextOutput);

        /*
        let openAISummaryPromise = [];
        for(let i=0; i<scrapeTextOutput.length; i++){
            let summaryPromise = this.getSingleSourceOpenAISummary(scrapeTextOutput[i]);
            openAISummaryPromise.push(summaryPromise);
        }
        let openAISummary = await Promise.all(openAISummaryPromise);
        // console.log(openAISummary);
        
        for(let i=0; i<newsArr.length; i++){
            if(openAISummary[i].trim().length>0){
                newsArr[i]['snippet'] = openAISummary[i];
            }
        }
        */

        let generalData = this.state.generalData;
        generalData['companyNews'] = newsArr;
        this.setState({generalData: generalData});
    }

    async getSingleSourceOpenAISummary(source){
        if(isNullOrUndefined(source))
            return "";
        let openAISummaryPromise = [];
        for(let i=0; i<source.length; i++){
            let text = source[i].trim();
            let summaryPromise = this.getOpenAISummary(text,'medium',20);
            openAISummaryPromise.push(summaryPromise);
        }
        let openAISummary = await Promise.all(openAISummaryPromise);
        let finalSummary = "";
        for(let i=0; i<openAISummary.length; i++){
            finalSummary += openAISummary[i];
            let currStr = openAISummary[i];
            if(!isNullOrUndefined(currStr))
                currStr = currStr.trim();
            if(!isNullOrUndefined(currStr) && currStr.length>0 && 
            (currStr[currStr.length-1]!='.' && currStr[currStr.length-1]!='?' && currStr[currStr.length-1]!=';')
            )
                finalSummary += "..";
            finalSummary += " ";
        }
        finalSummary = finalSummary.trim();
        if(finalSummary.length>350){
        //    finalSummary = finalSummary.substr(0,350) + "..."
        }
        return finalSummary;
    }

    async getOpenAISummary(text, quality, wordLimit){
        if(isNullOrUndefined(wordLimit))
            wordLimit = 40;
        if(isNullOrUndefined(quality))
            quality = "medium";
        if(isNullOrUndefined(text) || text.trim().length==0)
            return "";
        
        let output = {};
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/summarizeTextUsingOpenAI';
        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'text': text, 'length':wordLimit, "quality":quality}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            if('choices' in resJson && resJson['choices'].length>0){
                output = resJson['choices'][0]['text']
            }
        } 
        return output;
    }

    async scrapeSingleUrl(url, keyWords){
        if(isNullOrUndefined(url) || url.trim()=="")
            return [];
        let bodyJson = {'url': url}
        if(!isNullOrUndefined(keyWords))
            bodyJson['wordList']=keyWords;

        let output = [];
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/webParaScraperWithTextFilter';
        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify(bodyJson),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;
        } 
        return output;
    }

    async getCompanyGoogleSearchData(company){
        this.setLoadingState('google-search',true);

        if(!isNullOrUndefined(company) && company.trim().length>0){
            
            company = company.trim();

            let searchQueries = [{"q": company + " company", page:1}, {"q": company + " company", page:2}];
            let googleSearchResults = [];
            for(let i=0; i<searchQueries.length; i++){
                googleSearchResults.push(this.googleApiCall(searchQueries[i].q, searchQueries[i].page-1));
            }
            let resJsons = await Promise.all(googleSearchResults);
            this.getCompanyWikiData(resJsons, company)

        }

        this.setLoadingState('google-search',false);
    }

    async scrapeSingleWikiLink(url, companyStr){
        // console.log(url);
        let output = {};
        let companyStrings = [];
        if(!isNullOrUndefined(companyStr))
            companyStrings = companyStr;

        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeWikiForGeneralData';
        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'url': url, 'companyStrings':companyStrings}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            if(!isNullOrUndefined(resJson)){
                // console.log(resJson);
                let neededKeys = Const.generalWikiData;
                let extraKeys = Const.extraWikiData;
                let cnt = 0;
                for(let key in resJson){
                    for(let i=0; i<neededKeys.length;i++){
                        if(key.toLowerCase().includes(neededKeys[i])){
                            output[neededKeys[i]] = resJson[key];
                            cnt++;
                        }
                    }
                    for(let i=0; i<extraKeys.length;i++){
                        if(key.includes(extraKeys[i])){
                            output[extraKeys[i]] = resJson[key];
                        }
                    }
                }
                output['neededKeys_cnt'] = cnt;
            }
        }
        // console.log(output);
        return output;
    }

    async getCompanyCompetitors(company){

        let queryTexts = 
        [
            "who are "+company+" competitors?", 
            "who are main competitors of "+company+"?"
        ]
        
        let competitors = null;

        for(let i=0; i<queryTexts.length; i++){
            let queryText = queryTexts[i];

            let response = await this.googleApiCall(queryText);
            // console.log(response);
    
            competitors = await CoreHelper.parseCompetitorsSearchOutput(response, company);
            // console.log(competitors);

            if(!isNullOrUndefined(competitors))
                break;    
        }

        if(!isNullOrUndefined(competitors) && !isNullOrUndefined(competitors['data'])){
            let generalData = this.state.generalData;
            generalData["competitors"] = competitors;
            this.setState({
                generalData: generalData
            });
            this.getCyberIndustryNewsData(competitors.list);
        }
    }

    async getCompanyWikiData(resJsons, company){
        this.setLoadingState('wiki-data',true);

        //Wikipedia
        let wikiLinks = [];
        for(let i=0; !isNullOrUndefined(resJsons) && i<resJsons.length; i++){
            let currWikiLinks = Utils.getWikipediaLinks(resJsons[i]);
            wikiLinks = wikiLinks.concat(currWikiLinks);
        }

        // console.log(wikiLinks, resJsons);

        let wikiLinksApiCall = [];
        for(let i=0;!isNullOrUndefined(wikiLinks) && i<wikiLinks.length; i++){
            //TODO Make this parallel
            let url = wikiLinks[i].link;
            let companyStr = [];
            if(!isNullOrUndefined(company) && company.trim().length>0){
                companyStr = CoreHelper.createLinearSubstringsForCompany(
                    CoreHelper.getCompanyWords(company)
                );
            }
            wikiLinksApiCall.push(this.scrapeSingleWikiLink(url,companyStr));
        }

        let wikiLinksApiCallOutput = await Promise.all(wikiLinksApiCall);
        for(let i=0; i<wikiLinksApiCallOutput.length; i++){
            let output = wikiLinksApiCallOutput[i];
            wikiLinks[i]['data'] = output;
            wikiLinks[i]['dataCnt'] = output.neededKeys_cnt;    
        }

        wikiLinks.sort(function(a,b){
            return b.dataCnt - a.dataCnt
        });
        // console.log(wikiLinks);

        let generalData = this.state.generalData;
        let missingKeysQuery = Const.missingKeysQuery;
        let neededKeys = Const.generalWikiData;
        let missingKeys = [];
        let finalWikiLink = null;
        if(wikiLinks.length>0){
            finalWikiLink = wikiLinks[0];
            // console.log(finalWikiLink);
            
            //Do all the wiki stuff here            
            for(let i=0; i<neededKeys.length; i++){
                let key = neededKeys[i];
                if(key in finalWikiLink.data){
                    generalData[key] = 
                    { 'data': finalWikiLink.data[key], 'link': finalWikiLink.link}

                    if(key == 'industry' || key == 'key people'){
                        generalData[key].data = Utils.breakStringAfterScraping(generalData[key].data, ", ");
                    }
                }
                else if(key in missingKeysQuery){
                    missingKeys.push(key);
                }
            }


            //Wiki image
            if('imageLogo' in finalWikiLink.data){
                generalData['imageLogo'] = {
                    url: finalWikiLink.data.imageLogo
                }
            }
            if('summaryText' in finalWikiLink.data){
                generalData['summaryText'] = 
                {
                    'data': finalWikiLink.data['summaryText'],
                    'link': finalWikiLink.link
                }
            }
            // console.log(generalData);            
        }
        else{
            //All keys missing!

            for(let i=0; i<neededKeys.length; i++){
                let key = neededKeys[i];
                if(key in missingKeysQuery){
                    missingKeys.push(key);
                }
            }
        }

        //Public company
        if('type' in generalData && (generalData['type'].data =='Public' || generalData['type'].data.toLowerCase() =='public company')){
            generalData['isPublic'] = true;
            if(!isNullOrUndefined(finalWikiLink) && 'Traded as' in finalWikiLink.data){
                let tradedAs = finalWikiLink.data['Traded as']
                if(tradedAs.length>0)
                    this.stockTickerFromWikiApiCall(finalWikiLink.link, tradedAs)
            }

        }

        //If 'type is not in general data, then wiki page hasn't loaded. Most likely private because public companies have wiki page
        if(!('type' in generalData) ||
        (!(generalData['type'].data.trim().toLowerCase().includes('public')) && 
        !(generalData['type'].data.trim().toLowerCase().includes('subsidiary'))
        )
        ){
            generalData['isPrivate'] = true;
            this.getFundingData(company);
        }

        if(!('website' in generalData)){
            // Get website from Google search results instead
            if(!isNullOrUndefined(resJsons) && resJsons.length>0){
                let websiteLink = CoreHelper.getWebsiteFromGoogleSearchResults(resJsons[0], company);
                // console.log(websiteLink);
                if(!isNullOrUndefined(websiteLink) && websiteLink.length>0){
                    generalData['website'] = {
                        data: websiteLink,
                        link: websiteLink
                    }
                }
            }
        }

        //Push info currently available here
        this.setState({generalData: generalData});

        //Get techstack here
        if('website' in generalData && !isNullOrUndefined(generalData['website'].data)){
            this.getWebsiteTechStack(generalData['website'].data);
        }

        //get competitors
        this.getCompanyCompetitors(company);

        this.setLoadingState('wiki-data',false);

        // console.log(missingKeys);
        
        this.postWikiFunction(missingKeys, generalData, company);
    }

    async postWikiFunction(missingKeys, generalData, company){
        if(missingKeys.length>0){
            await this.getMissingWikiKeysWrapper(missingKeys, company);
        }
        if(('industry' in generalData) && isNullOrUndefined(generalData['industry'].isSnippet)){
            let industryStr = generalData['industry'].data;
            if(!isNullOrUndefined(industryStr)){
                let industries = industryStr.split(",").join(";").split(";")
                // console.log(industries);
                this.getCyberIndustryNewsDataV2(industries);
            }
        }
    }

    async getMissingWikiKeysWrapper(missingKeys, company){
        let generalData = this.state.generalData;
        let output = await this.getMissingWikiKeys(missingKeys, company);
        // console.log(output);

        if(!isNullOrUndefined(output)){
            for(var key in output){
                generalData[key] = output[key];
            }
        }

        // console.log(generalData);

        this.setState({generalData: generalData});    
    }

    async getMissingWikiKeys(missingKeys, company){

        // console.log(missingKeys);
        let finalOutput = {};

        if(!isNullOrUndefined(company) && company.trim().length>0){
            let dataOutput = [];
            company = company.trim();
    
            let missingKeysQuery = Const.missingKeysQuery;
            let prOutput = [];
            for(let j=0; j<missingKeys.length; j++){
                if(missingKeys[j] in missingKeysQuery){
                    let queryArr = missingKeysQuery[missingKeys[j]];
                    let query = queryArr[0]+company+queryArr[1];
                    let currOutput = this.googleApiCall(query);
                    prOutput.push(currOutput);
                    dataOutput.push({
                        'key': missingKeys[j],
                        'data': {}
                    })
                }
            }

            let output = await Promise.all(prOutput);
            // console.log(output);
            if(!isNullOrUndefined(output)){
                for(let i=0;i<output.length;i++){
                    dataOutput[i].data = CoreHelper.getGoogleAnswer(output[i]);
                    if(Object.keys(dataOutput[i].data).length>0)
                        finalOutput[dataOutput[i].key] = dataOutput[i].data;
                }
            }

            let snippetKeys = {}, snippetText = "";
            for(let key in finalOutput){
                if(finalOutput[key].isSnippet && 'data' in  finalOutput[key] && finalOutput[key].data.trim().length>0){
                    let text = finalOutput[key].data.trim();
                    snippetKeys[key] = {
                        start: snippetText.length,
                        end: snippetText.length + text.length + 1
                    }
                    snippetText += text + ". ";
                }
            }
            // console.log(finalOutput);
            // console.log(snippetKeys, snippetText);

            if(snippetText.trim().length>0){
                let nlpMissingKeys = await this.googleNlpEntityExtraction(snippetText);
                // console.log(nlpMissingKeys);

                let nlpAnswers = CoreHelper.getNlpGoogleAnswer(snippetKeys, nlpMissingKeys, snippetText);
                // console.log(nlpAnswers);
                for(let key in nlpAnswers){
                    if(key in finalOutput){
                        finalOutput[key].data = nlpAnswers[key];
                        delete finalOutput[key].isSnippet;
                    }
                }
            }
            // console.log(output,finalOutput);
            
        }
        else{
            return {};
        }
        return finalOutput;
    }

    async stockTickerFromWikiApiCall(wikiUrl, ticker_arr){
        if(!isNullOrUndefined(ticker_arr)){
            let tickers = ticker_arr;
            let generalData = this.state.generalData;
            generalData['stockTickers'] = tickers;
            this.setState({
                generalData: generalData
            })
    
            //Get public stock data
            this.getPublicStockRelatedData(tickers);    
        }
      /*
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeWikiForStockTicker';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'url': wikiUrl}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    

            if(!isNullOrUndefined(output) && 'ans' in output){
                let tickers = output.ans;
                let generalData = this.state.generalData;
                generalData['stockTickers'] = tickers;
                this.setState({
                    generalData: generalData
                })

                //Get public stock data
                this.getPublicStockRelatedData(tickers);
            }
        }
        */
    }

    async getFundingData(company){
        if(!isNullOrUndefined(company) && company.trim().length>0){
            let searchQ = company + " funding news";

            let googleList = await this.googleApiCall(searchQ);

            let finOutput = CoreHelper.getFundingFromGoogleSearch(googleList, company);
            // console.log(googleList, finOutput);
            // console.log(finOutput);

            if(finOutput.length>0){
                let generalData = this.state.generalData;
                generalData['funding'] = finOutput;
                this.setState({
                    generalData: generalData
                });
            }
        }

    }

    async googleNewsApiCall(searchQuery){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleNewsPull';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'query': searchQuery}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    async googleApiCall(searchQuery, pageOffset, extraParams){

        if(isNullOrUndefined(pageOffset)){
            pageOffset = 0;
        }
        else{
            pageOffset *= 10;
        }

        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/googleSearchPull';
        let output = {};

        output = await DbUtils.readGoogleSearchDataFromDb('google-search', searchQuery, pageOffset);
        if(!isNullOrUndefined(output) && Object.keys(output).length>0){
            // console.log("From db:", output);
            return output;
        }
            
        // console.log(endpoint);
        // console.log(searchQuery);

        // console.log(JSON.stringify({'query': searchQuery, 'startOffset': pageOffset}))

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'query': searchQuery, 'startOffset': pageOffset}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        if(Object.keys(output).length>0){
            //write to db
            let queryParams = {'query':searchQuery, 'pageOffset': pageOffset};
            let additionalParams = {};
            if(!isNullOrUndefined(extraParams)){
                additionalParams = extraParams;
            }
            DbUtils.writeGoogleSearchToDb('google-search',queryParams,output,extraParams);
        }
        return output
    }

    async googleApiCallListResults(searchQuery, pageOffset, additionalParams){
        let results = await this.googleApiCall(searchQuery, pageOffset, additionalParams);
        let arr = [];
        if('answer_box' in results){
            let answerBox = results['answer_box']
            if('link' in answerBox && 'title' in answerBox){
                arr.push(answerBox);
            }
        }
        if('organic_results' in results){
            let organicResults = results['organic_results'];
            for(let i=0; !isNullOrUndefined(organicResults) && i<organicResults.length; i++){
                arr.push(organicResults[i]);
            }
        }
        return arr;
    }

    getGeneralDataFromDb(){

    }

    toggleGeneralFilter(option){
        let generalFilters = this.state.generalFilters;
        if(!isNullOrUndefined(option) && option in generalFilters){
            generalFilters[option] = !generalFilters[option];
            this.setState({
                generalFilters: generalFilters
            });
        }
    }

 

    async googleNlpEntityExtraction(text){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/entityExtraction';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'text':text}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output
    }

    async getPublicStockRelatedData(stockTickers){
        if(!isNullOrUndefined(stockTickers) && stockTickers.length>0){
            let mainTicker = stockTickers[0];

            //tenK cyber data
            this.getTenK_cyberData(mainTicker);

            let allOutputs = [];

            //1: Financial data
            let incomeStatement = this.yahooIncomeStatementApiCall(mainTicker);
            allOutputs.push(incomeStatement);

            let res = await Promise.all(allOutputs);
            let generalData = this.state.generalData;
            // console.log(res);

            if(res.length>=1 && !isNullOrUndefined(res[0])){
                let incomeStatement = res[0];
                generalData['incomeStatement'] = {
                    data: incomeStatement,
                    link: 'https://finance.yahoo.com/quote/' + mainTicker + '/financials'
                }

                //Income statement exists for this stock. It is a US stock. SEC filings must mostly exist for this too.
                // Pull SEC filings (put in the)
                // CoreHelper.saveSecInDbApiCall(mainTicker,"10-K");
            }

            this.setState({
                generalData: generalData
            });
        }
    }

    async yahooIncomeStatementApiCall(stock){
        const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeYahooForIncomeStatement';
        let output = {};
        // console.log(endpoint);
        // console.log(searchQuery);

        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'stock': stock}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    

            let link = 'https://finance.yahoo.com/quote/' + stock + '/financials';
            DbUtils.writeYahooIncomeStatementToDb(stock,output,link);
        }
        return output
    }

    async getWebsiteTechStack(website){

        this.setLoadingState(true,'websiteTechStack');

        if(!website.includes('https://') && !website.includes('http://')){
            website = "https://" + website;
        }
        website = CoreHelper.getUrlFullBase(website)
        // console.log(website);
        if(isNullOrUndefined(website))
            return;
        let output = await CoreHelper.getWebsiteBuiltWithDataFromDb(website);
        // console.log("dboutput",output)
        /* if(isNullOrUndefined(output)){
            output = await CoreHelper.getWebsiteBuiltWithDataFromApi(website);
            console.log("apiOutput",output);
            CoreHelper.saveWebsiteBuiltWithDataToDb(website,output);
        } */

        if(!isNullOrUndefined(output)){
            let websiteTechStack = output['techList'];
            if(!isNullOrUndefined(websiteTechStack)){
                let generalData = this.state.generalData;
                generalData['websiteTechStack'] = websiteTechStack;
                this.setState({generalData: generalData});
            }
        }

        this.setLoadingState(false,'websiteTechStack');
    }

    clickOnKeyWordFilter(keyWords){
        if(isNullOrUndefined(keyWords))
            return;
        let keywordFilterCategories = this.state.keywordFilterCategories;
        keywordFilterCategories = keyWords;
        // console.log(keywordFilterCategories);
        this.setState({
            keywordFilterCategories: keywordFilterCategories
        });
    }

    componentWillUnmount(){
        
    }

    componentDidMount(){

        if(!isNullOrUndefined(this.props.company) && this.props.company.length>0){
            let meeting = this.state.meeting;
            meeting.company = this.props.company;
            this.setState({
                meeting: meeting
            });
            this.getAllData(this.props.company);
        }

    }

    componentWillReceiveProps(nextProps){
        if(nextProps.company != this.state.meeting.company){
            let meeting = this.state.meeting;
            meeting.company = nextProps.company;
            this.setState({
                meeting: meeting
            });
            if(!isNullOrUndefined(nextProps.company) && nextProps.company.length>0){
                this.getAllData(nextProps.company);
            }
        }

    }

    async createTempMeeting(company, attendees){
        if(!isNullOrUndefined(company) && company.trim().length>0){
            company = company.trim();
            let meeting = this.state.meeting;
            meeting.company = company;
            firebase.analytics().logEvent('company_lookup',{
                name: company
            });
            firebase.analytics().setUserProperties({company: company});
            this.setState({
                meeting: meeting,
                generalData: {}
            });
            // console.log(meeting);
            this.getAllData(company);
        }
    }

    getDocument(){
        return (
            <Document>
              <Page size="A4" >
                <View >
                  <Text>Section #1</Text>
                </View>
                <View>
                  <Text>Section #2</Text>
                </View>
              </Page>
            </Document>
        )
    }

    setAmChart(chartName, chart){
        if(!isNullOrUndefined(chartName)){
            let amCharts = this.state.amCharts;
            if(isNullOrUndefined(chart)){
                delete amCharts[chartName];
            }
            else{
                amCharts[chartName] = chart;
            }
            this.setState({ amCharts: amCharts});
        }
    }

    handleFilterKeywordChange(event){
        // console.log(event.target);
        if(!isNullOrUndefined(event.target) && !isNullOrUndefined(event.target.value)){
             let justSelected = event.target.value;
             // console.log(justSelected);
             // console.log(event.target.value);
             if(!isNullOrUndefined(this.clickOnKeyWordFilter)){
                this.clickOnKeyWordFilter(justSelected);
             }
        }
 
     }

    renderKeywordsFilter(){
        const ITEM_HEIGHT = 48;
        const ITEM_PADDING_TOP = 8;
        const MenuProps = {
            PaperProps: {
              style: {
                maxHeight: '200px',
                width: '250px',
              },
            },
          };

        return (
            <div>
                <FormControl style={{margin: '10px', minWidth: '120px', maxWidth: '300px'}}>
                    <InputLabel id="demo-mutiple-name-label">Filter</InputLabel>
                    <Select
                    labelId="demo-mutiple-name-label"
                    id="demo-mutiple-name"
                    multiple
                    value={this.state.keywordFilterCategories}
                    onChange={this.handleFilterKeywordChange}
                    input={<Input />}
                    >
                    {Const.cyberNewsKeywordsFilterCategory.map((name) => {
                        if(this.state.keywordFilterCategories.includes(name))
                            return (
                                <MenuItem key={name} value={name} style={{fontWeight:'bold'}}>
                                    {name}
                                </MenuItem>
                            )
                        return (
                            <MenuItem key={name} value={name}>
                                {name}
                            </MenuItem>
                        )
                            })}
                    </Select>
                </FormControl>
            </div>
        )
    }

    render(){
        
        let downloadFileName = "";
        if(this.state.meeting && !isNullOrUndefined(this.state.meeting.company)){
            downloadFileName = this.state.meeting.company+"-premeeting-brief.pdf";
        }
        return (
            <div>
                <div>
                    <div style={{textAlign: 'left'}}>
                        {!isNullOrUndefined(this.state.generalData) && Object.keys(this.state.generalData).length>0 
                        && this.props.userId && this.props.userId.trim().length>0?
                            <PDFDownloadLink document={GeneralDataPdfUtils.renderGeneralDataPdf(this.state.generalData, this.state.amCharts)} fileName={downloadFileName}>
                                {({ blob, url, loading, error }) => (
                                    <Button
                                    color="primary"
                                    variant="contained"
                                    className="genericButton_v1" 
                                    style={{marginLeft: '1em', marginBotton:'0'}}
                                    onClick={() => {AnalyticsUtils.logButtonClick('download_full_report',{'name': this.state.meeting.company})}}>
                                        Download Report
                                    </Button>                
                                )}
                            </PDFDownloadLink>
                            :
                            null
                                }
                    </div>
                        
                    
                    {!isNullOrUndefined(this.state.generalData) && Object.keys(this.state.generalData).length>0 
                        && this.state.flags.showGeneralFilters?
                        <div>
                            <GeneralFiltersComponent 
                                generalFilters = {this.state.generalFilters}
                                toggleGeneralFilter = {this.toggleGeneralFilter}
                            />
                        </div>
                        :
                        null
                    }

                    

                    {!isNullOrUndefined(this.state.meeting.company) && this.state.meeting.company.trim().length>0?
                        <div style={{marginTop:'5'}}>
                            <div style={{textAlign:'left', marginLeft: '1em'}}>
                                {this.renderKeywordsFilter()}
                            </div>
                            <GeneralDataComponent
                                generalData = {this.state.generalData}
                                generalFilters = {this.state.generalFilters}
                                getAllData = {this.getAllData}
                                getCompanyMission = {this.getCompanyMission}
                                getCompanyGoogleSearchData = {this.getCompanyGoogleSearchData}
                                getCompanyGoogleNewsData = {this.getCompanyGoogleNewsData}
                                getPublicStockRelatedData = {this.getPublicStockRelatedData}
                                getFundingData = {this.getFundingData}
                                keywordFilterCategories = {this.state.keywordFilterCategories}
                                clickOnKeyWordFilter = {this.clickOnKeyWordFilter}
                                userId = {this.props.userId}
                                isLoading = {this.state.isLoading}
                                newsSummaries = {this.state.newsSummaries}
                                />
                        </div>
                        :
                        null
                    }       

                    {!isNullOrUndefined(this.state.meeting.company) && this.state.meeting.company.trim().length>0
                        && !isNullOrUndefined(this.state.generalData) && Object.keys(this.state.generalData).length>0 
                        && this.state.showFeedback?
                        <FeedbackFormComponent 
                            company = {this.state.meeting.company}
                        />
                        :
                        null
                    }         
                </div>
            </div>
        )
    }
}
export default MeetingV1Component;

//TODO Undo, reset